<template>
  <div class="d-flex flex-grow-1 flex-column">
    <v-row class="flex-grow-0" dense>
      <v-col cols="12" xl="12">
        <div class="flexDiv">
          <div
            class="viewer_container 0"
            id="3d"
            :style="{ display: `${is3d}` }"
          ></div>
          <div
            class="viewer_container 1"
            id="2d"
            :style="{ display: `${is2d}` }"
          ></div>
          <div
            class="viewer_container 2"
            id="2d_view"
            :style="{ display: `${is22d}` }"
          ></div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import viewBtnCellRenderer from "../viewRequirement.js";
import * as THREE from "three";
import {
  createViewer,
  viewer_3d,
  viewer_2d,
  viewer_2d_building
} from "@/store/viewer_man";
export default {
  components: {
  },
  props: {
    modelURN: {
      type: String,
      default: null
    },
    viewType: {
      type: String,
      default: "3d view"
    },
    elevationType: {
      type: String,
      default: null
    },
    floorLevel: {
      type: String,
      default: null
    },
    selectedScheduleItems: {
      type: Array,
      default: null
    },
    selectedWindow: {
      type: Object,
      default: null
    }
  },
  created() {
    // this.selectedItem = this.$store.state.window.selectedItems;
    // console.log("Project Detail Page", this.selectedItem);
    // this.itemVersions = this.selectedItem.versions;
    // this.getScheduleItemVersion(this.selectedItem);
    if (this.modelURN) {
      this.URN = this.modelURN;
    }

    this.getView(this.viewType);
  },
  destroyed() {
    viewer_3d.uninitialize();
    viewer_2d.uninitialize();
    viewer_2d.viewer_2d_building.uninitialize();

    viewer_3d.shutdown();
    viewer_2d.shutdown();
    viewer_2d.viewer_2d_building.shutdown();

    // new window.Autodesk.Viewing.shutdown();
  },
  watch: {
    modelURN(val) {
      if (val && this.URN !== val) {
        this.URN = val;
        this.loadViewer();
      }
    },
    viewType(val) {
      this.getView(val);
    },
    elevationType(val) {
      this.getElevation(val);
    },
    floorLevel(val) {
      this.getFloor(val);
    },
    selectedWindow(val) {
      window.scrollTo(0, 0);
      this.getRequirements(val);
      // if (val.type === "single_item") {
      //   this.getRequirements(val);
      // } else {
      //   this.getGroupedItem(this.model);
      // }
    },
    modelInfo(val) {
      if (val) {
        this.model = { ...val };
        console.log("MODEL: ", val);
      }
    }
  },
  mounted() {
    //this.selectedScheduleItems = this.$store.state.window.scheduleItems;

    //Initialize the levels array
    // this.floors = this.selectedScheduleItems.map(s => "Level " + s.level);
    // let items = this.selectedScheduleItems;

    // console.log("windows items", this.selectedItem);

    // this.selectedVersion = this.selectedItem.versions[
    //   this.selectedItem.versions.length - 1
    // ].version_number;
    // this.URN = this.selectedItem.versions[
    //   this.selectedItem.versions.length - 1
    // ].URN;
    // this.URN =
    //   "dXJuOmFkc2sub2JqZWN0czpvcy5vYmplY3Q6cnVzaGFiaGF0ZW1haWxkb3Rjb20tcHJval9vbmVfMjRfanVuXzIwMjEtc2NoX29uZV8yNF9qdW5fMjAyMS9EZW1vX01vZGVsX0phbjIwMjFfMS5ydnQ";
    // createViewer({
    //   URN: "urn:" + this.URN,
    //   windowElement_3d: document.getElementById("3d"),
    //   windowElement_2d: document.getElementById("2d"),
    //   windowElement_2d_building: document.getElementById("2d_view"),
    //   items: items
    // });

    this.loadViewer();

    // console.log("check demo",schedulrItems);
  },
  computed: {
    ...mapGetters([
      "tabs",
      "windowHeaders",
      "windowData",
      "collaboratorsCount",
      "modelInfo"
    ]),

    getModel() {
      return this.$store.getters["modelInfo"];
    },

    total_cost() {
      var total = 0.0;
      this.selectedScheduleItems.forEach(item => {
        total = total + item.windowPrice;
      });
      return total;
    }
  },
  methods: {
    ...mapActions(["toggleCollaboratorsModal", "toggleAddWindowScheduleModal"]),
    ...mapMutations(["hideModal"]),
    loadViewer() {
      let items = this.selectedScheduleItems;

      createViewer({
        URN: "urn:" + this.URN,
        windowElement_3d: document.getElementById("3d"),
        windowElement_2d: document.getElementById("2d"),
        windowElement_2d_building: document.getElementById("2d_view"),
        items: items
      });
    },
    getElevation(value) {
      // let elevations = "Elevation:" + " " + value;
      createViewer({
        URN: "urn:" + this.URN,
        windowElement_3d: document.getElementById("3d"),
        windowElement_2d: document.getElementById("2d"),
        windowElement_2d_building: document.getElementById("2d_view"),
        elevation: value,
        items: this.selectedScheduleItems
      });
    },
    getFloor(vlaue) {
      createViewer({
        URN: "urn:" + this.URN,
        // windowElement: document.getElementById("3d"),
        windowElement_3d: document.getElementById("3d"),
        windowElement_2d: document.getElementById("2d"),
        windowElement_2d_building: document.getElementById("2d_view"),
        floor: vlaue,
        items: this.selectedScheduleItems
      });
    },
    getView(value) {
      if (value == "3d view") {
        this.is3d = "block";
        this.is2d = "none";
        this.is22d = "none";

        // this.URN=version.URN;
        createViewer({
          URN: "urn:" + this.URN,
          // windowElement: document.getElementById("3d"),
          windowElement_3d: document.getElementById("3d"),
          windowElement_2d: document.getElementById("2d"),
          windowElement_2d_building: document.getElementById("2d_view"),
          items: this.selectedScheduleItems
        });
      }
      if (value == "2d geometry") {
        this.is3d = "none";
        this.is2d = "block";
        this.is22d = "none";

        createViewer({
          URN: "urn:" + this.URN,
          // windowElement: document.getElementById("3d"),
          windowElement_3d: document.getElementById("3d"),
          windowElement_2d: document.getElementById("2d"),
          windowElement_2d_building: document.getElementById("2d_view"),
          items: this.selectedScheduleItems
        });
      }
      if (value == "2d view") {
        this.is3d = "none";
        this.is2d = "none";
        this.is22d = "block";

        createViewer({
          URN: "urn:" + this.URN,
          // windowElement: document.getElementById("3d"),
          windowElement_3d: document.getElementById("3d"),
          windowElement_2d: document.getElementById("2d"),
          windowElement_2d_building: document.getElementById("2d_view"),
          items: this.selectedScheduleItems
        });
      }
    },

    zoomWindow(viewer, model, dbId) {
      console.log(dbId);
      viewer.impl.fitToView(model.getData().urn);
    },

    getGroupedItem(model) {
      console.log(model);
      if (this.selectedWindow && this.selectedWindow.type === undefined) {
        let strId;
        const items = this.model.stringDbIds;
        console.log(items);
        let ids = [];
        for (let i = 0; i < items.length; i++) {
          ids.push("[" + items[i] + "]");
        }
        strId = ids;

        console.log("STR ID: " + strId);
        // viewer_3d.isolate(strId);

        if (this.viewType == "3d view") {
          this.is3d = "block";
          this.is2d = "none";
          this.is22d = "none";
          viewer_3d.select(strId, "Autodesk.Viewing.SelectionMode.REGULAR");
          viewer_3d.isolate(strId);

          setTimeout(function() {
            viewer_3d.showAll();
            viewer_3d.clearSelection();

            //Change Camera Position
            var nav = viewer_3d.navigation;
            var pos = nav.getPosition();
            var target = nav.getTarget();
            var viewdir = new THREE.Vector3();
            viewdir.subVectors(pos, target).normalize();

            // zooms out by 100 along the view direction
            viewdir.multiplyScalar(150);
            pos.add(viewdir);
            nav.setPosition(pos);
          }, 10000);
        } else if (this.viewType == "2d geometry") {
          this.is3d = "none";
          this.is2d = "block";
          this.is22d = "none";
          viewer_2d.select(strId, "Autodesk.Viewing.SelectionMode.REGULAR");
          viewer_2d.fitToView(strId);
        } else if (this.viewType == "2d view") {
          this.is3d = "none";
          this.is2d = "none";
          this.is22d = "block";
          viewer_2d_building.select(
            strId,
            "Autodesk.Viewing.SelectionMode.REGULAR"
          );
          viewer_2d_building.fitToView(strId);
          viewer_2d_building.isolate(strId);

          setTimeout(function() {
            viewer_2d_building.showAll();
            viewer_2d_building.clearSelection();

            //Change Camera Position
            var nav = viewer_2d_building.navigation;
            var pos = nav.getPosition();
            var target = nav.getTarget();
            var viewdir = new THREE.Vector3();
            viewdir.subVectors(pos, target).normalize();

            // zooms out by 100 along the view direction
            viewdir.multiplyScalar(10);
            pos.add(viewdir);
            nav.setPosition(pos);
          }, 10000);
        }
      }
    },

    getRequirements(item) {
      // this.viewType = "3d view";
      console.log("ITEM: ", item);
      console.log("VIEW TYPE: ", this.viewType);
      let strId;
      if (item.length > 1) {
        let ids = [];
        for (let i = 0; i < item.length; i++) {
          ids.push("[" + item[i].strID + "]");
        }
        strId = ids;

        console.log("STR ID: " + strId);
        // viewer_3d.isolate(strId);

        if (this.viewType == "3d view") {
          this.is3d = "block";
          this.is2d = "none";
          this.is22d = "none";
          viewer_3d.select(strId, "Autodesk.Viewing.SelectionMode.REGULAR");
          viewer_3d.isolate(strId);

          setTimeout(function() {
            viewer_3d.showAll();
            viewer_3d.clearSelection();

            //Change Camera Position
            var nav = viewer_3d.navigation;
            var pos = nav.getPosition();
            var target = nav.getTarget();
            var viewdir = new THREE.Vector3();
            viewdir.subVectors(pos, target).normalize();

            // zooms out by 100 along the view direction
            viewdir.multiplyScalar(150);
            pos.add(viewdir);
            nav.setPosition(pos);
          }, 10000);
        } else if (this.viewType == "2d geometry") {
          this.is3d = "none";
          this.is2d = "block";
          this.is22d = "none";
          viewer_2d.select(strId, "Autodesk.Viewing.SelectionMode.REGULAR");
          viewer_2d.fitToView(strId);
        } else if (this.viewType == "2d view") {
          this.is3d = "none";
          this.is2d = "none";
          this.is22d = "block";
          viewer_2d_building.select(
            strId,
            "Autodesk.Viewing.SelectionMode.REGULAR"
          );
          viewer_2d_building.fitToView(strId);
          viewer_2d_building.isolate(strId);

          setTimeout(function() {
            viewer_2d_building.showAll();
            viewer_2d_building.clearSelection();

            //Change Camera Position
            var nav = viewer_2d_building.navigation;
            var pos = nav.getPosition();
            var target = nav.getTarget();
            var viewdir = new THREE.Vector3();
            viewdir.subVectors(pos, target).normalize();

            // zooms out by 100 along the view direction
            viewdir.multiplyScalar(10);
            pos.add(viewdir);
            nav.setPosition(pos);
          }, 10000);
        }
      } else {
        console.log("MODEL ID: ", item.model_id);
        strId = item.model_id;
        strId = "[" + strId + "]";

        console.log("selected model", strId);

        if (this.viewType == "3d view") {
          viewer_3d.search(strId, function(params) {
            this.is3d = "block";
            this.is2d = "none";
            this.is22d = "none";

            viewer_3d.select(params, "Autodesk.Viewing.SelectionMode.REGULAR");
            viewer_3d.fitToView(params);
            viewer_3d.isolate(params);

            // const myDbid = viewer_3d.getSelection();
            // viewer_3d.getProperties(myDbid, function(e) {
            //   console.log("Entire object response ", e);
            //   console.log("Properties ", e.properties);
            // });

            setTimeout(function() {
              viewer_3d.showAll();
              viewer_3d.clearSelection();

              //Change Camera Position
              var nav = viewer_3d.navigation;
              var pos = nav.getPosition();
              var target = nav.getTarget();
              var viewdir = new THREE.Vector3();
              viewdir.subVectors(pos, target).normalize();

              // zooms out by 100 along the view direction
              viewdir.multiplyScalar(150);
              pos.add(viewdir);
              nav.setPosition(pos);
            }, 10000);
          });
        } else if (this.viewType == "2d geometry") {
          this.is3d = "none";
          this.is2d = "block";
          this.is22d = "none";

          viewer_2d.search(strId, function(params) {
            viewer_2d.select(params, "Autodesk.Viewing.SelectionMode.REGULAR");
            viewer_2d.fitToView(params);
            //viewer_2d.isolate(params);
          });
        } else if (this.viewType == "2d view") {
          this.is3d = "none";
          this.is2d = "none";
          this.is22d = "block";

          //viewer_2d_building.clearSelection();
          //viewer_2d_building.set2dSelectionColor(red)

          const bounds = this.getBounds2D(viewer_2d, viewer_2d.model, strId);
          // const coords = viewer_2d.worldToClient(bounds.center());

          viewer_2d_building.search(strId, function(params) {
            viewer_2d_building.select(
              params,
              "Autodesk.Viewing.SelectionMode.REGULAR"
            );
            viewer_2d_building.fitToView(params);
            viewer_2d_building.isolate(params);

            setTimeout(function() {
              viewer_2d_building.showAll();
              viewer_2d_building.clearSelection();

              //Change Camera Position
              var nav = viewer_2d_building.navigation;
              var pos = nav.getPosition();
              var target = nav.getTarget();
              var viewdir = new THREE.Vector3();
              viewdir.subVectors(pos, target).normalize();

              // zooms out by 100 along the view direction
              viewdir.multiplyScalar(10);
              pos.add(viewdir);
              nav.setPosition(pos);
            }, 10000);
          });
        }
      }
    },

    getBounds2D(viewer, model, dbId) {
      const frags = model.getFragmentList();
      console.log("frags found", frags);
      let bounds = new THREE.Box3();
      let boundsCallback = new window.Autodesk.Viewing.Private.BoundsCallback(
        bounds
      );
      let fragIds = frags.fragments.dbId2fragId[dbId]; // Find all fragments including this object's primitives
      if (!Array.isArray(fragIds)) {
        fragIds = [fragIds];
      }
      for (const fragId of fragIds) {
        console.log("FRAG ID: ", fragId);
        // Get the actual mesh with all geometry data for given fragment
        const mesh = frags.getVizmesh(fragId);
        const vbr = new Autodesk.Viewing.Private.VertexBufferReader(
          mesh.geometry,
          viewer.impl.use2dInstancing
        );
        vbr.enumGeomsForObject(dbId, boundsCallback); // Update bounds based on all primitives linked to our dbId
      }
      return bounds;
    }
  },
  data() {
    return {
      viewer: null,
      scheduleLevels: [],
      scheduleItems: [],
      changeModal: false,
      model: null,
      searchText: "",
      numitems: 0,
      is3d: "block",
      is2d: "none",
      is22d: "none",
      floors: [], // ["Level 1", "Level 2", "Level 3", "Level 4"],
      setFloor: "",
      tab: null,
      URN: null,
      columnValues: [],
      selectedItem: [],
      schedule: [],
      itemVersions: [],
      selectedVersion: null,
      versions: ["1", "2", "3"],
      version: null,
      columns: ["Mark", "Width", "Height"],
      searchString: "",
      frameworkComponents: {
        viewBtnCellRenderer
      }
    };
  }
};
</script>

<style lang="scss">
@media (min-width: 500px) {
  .modal-lg {
    max-width: auto !important;
  }
}

@media (min-width: 300px) {
  .modal-dialog {
    max-width: auto !important;
  }
}

.flexDiv {
  display: flex;
  height: 100%;
  flex-direction: row;
  width: 100%;

  background: rebeccapurple;
}

.viewer_container {
  position: relative;
  height: 450px;
  width: 100%;
}

.v-btn:not(.v-btn--round).v-size--large {
  height: 56px;
}

.v-input__slot {
  margin-bottom: 0px !important;
}

.v-content .v-card.v-sheet.theme--light {
  background-color: #ffffff !important;
  border-left: 5px solid #424242 !important;
}

.v-sheet
  v-sheet--tile
  theme--light
  v-toolbar
  v-toolbar--flat
  v-app-bar
  v-app-bar--fixed {
  left: 0px !important;
}

.v-text-field fieldset,
.v-text-field .v-input__control,
.v-text-field .v-input__slot .v-label {
  font-size: 0.9em;
  border-radius: inherit;
}

.v-list-item__title {
  font-size: 0.8rem;
}

.v-list-item--dense .v-list-item__title,
.v-list-item--dense .v-list-item__subtitle,
.v-list--dense .v-list-item .v-list-item__title,
.v-list--dense .v-list-item .v-list-item__subtitle {
  font-size: 0.8rem;
  font-weight: 500;
  line-height: 1rem;
}

.v-select__selections {
  font-size: 0.8rem;
  align-items: center;
  display: flex;
  flex: 1 1;
  flex-wrap: wrap;
  line-height: 18px;
  max-width: 100%;
  min-width: 0;
}
</style>
